import type { FileChangesResponse, FileTreeResponse } from "@/hooks/use-file-data"

export const SESSION_FILE_TREE_UPDATED_EVENT = "cord:session-file-tree-updated"
export const SESSION_FILE_CHANGES_UPDATED_EVENT = "cord:session-file-changes-updated"

export interface SessionFileTreeUpdatedDetail {
  sessionId: string
  data: FileTreeResponse
}

export interface SessionFileChangesUpdatedDetail {
  sessionId: string
  data: FileChangesResponse
}

export function dispatchSessionFileTreeUpdated(detail: SessionFileTreeUpdatedDetail): void {
  if (typeof window === "undefined") return
  window.dispatchEvent(new CustomEvent<SessionFileTreeUpdatedDetail>(SESSION_FILE_TREE_UPDATED_EVENT, { detail }))
}

export function dispatchSessionFileChangesUpdated(detail: SessionFileChangesUpdatedDetail): void {
  if (typeof window === "undefined") return
  window.dispatchEvent(new CustomEvent<SessionFileChangesUpdatedDetail>(SESSION_FILE_CHANGES_UPDATED_EVENT, { detail }))
}
